import { calendar_v3 } from "googleapis";
import { CalendarEvent } from "../types/CalendarEvent";

export const createCalendarEvent = async (
  accessToken: string,
  event: CalendarEvent
) => {
  try {
    const response = await fetch(
      "https://www.googleapis.com/calendar/v3/calendars/primary/events",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(event),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to create event: ${response.statusText}`);
    }

    /** 
      {
        "kind": "calendar#event",
        "etag": "\"3507621724115902\"",
        "id": "bdkmj2g8lnkaubhg8f59qf1b90",
        "status": "confirmed",
        "htmlLink": "https://www.google.com/calendar/event?eid=YmRrbWoyZzhsbmthdWJoZzhmNTlxZjFiOTAgZ2VvcmdlLm1pa2VAbQ",
        "created": "2025-07-29T17:41:01.000Z",
        "updated": "2025-07-29T17:41:02.057Z",
        "summary": "Test Earnings Event",
        "description": "This is just a test event",
        "creator": {
            "email": "george.mike@gmail.com",
            "self": true
        },
        "organizer": {
            "email": "george.mike@gmail.com",
            "self": true
        },
        "start": {
            "dateTime": "2025-07-30T16:00:00-04:00",
            "timeZone": "America/New_York"
        },
        "end": {
            "dateTime": "2025-07-30T16:00:00-04:00",
            "timeZone": "America/New_York"
        },
        "iCalUID": "bdkmj2g8lnkaubhg8f59qf1b90@google.com",
        "sequence": 0,
        "reminders": {
            "useDefault": true
        },
        "eventType": "default"
      }
     */

    const data = (await response.json()) as calendar_v3.Schema$Event;
    const success = data.status === "confirmed";
    return { data, success };
  } catch (err) {
    const success = false;
    return { data: null, success };
  }
};
